import script from "./DefLabelsTagsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefLabelsTagsModal.vue?vue&type=script&lang=ts&setup=true"

import "./DefLabelsTagsModal.vue?vue&type=style&index=0&id=c5b3a39a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5b3a39a"]])

export default __exports__